import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'
import { PromotionDecisionRate } from '../types/insights'

export function usePromotionDecisionRate() {
  return useQuery({
    queryKey: ['insights', 'promotion-decision-rate'],
    queryFn: async () => {
      const response = await get<{ data: PromotionDecisionRate[] }>('/insights/promotion-decision-rate')
      return response.data
    },
    staleTime: Infinity, // Historical data never changes
    gcTime: Infinity,
  })
} 